import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import { HubConnectionBuilder, HttpTransportType } from '@aspnet/signalr';

export default {
  name: 'billing',
  components: {
    TreeSelect: require('../../customcontrols/selectOfTree.vue').default,
    billingStep: require('./billingStep/billingStep.vue').default,
    createBillingCycle: require('./createBillingCycle/createBillingCycle.vue').default,
    reportsComp: require('../../common/reports/reports.vue').default,
  },
  data: function () {
    return {
      userBillingGroups: [],
      globalPayByDate: false,
      connection: null,
      thisPage: null,
      reports: [],
      onlyOpen: true,
      billingGroups: [],
      billingGroup: '',
      selectedBillingGroup: null,
      showCloseCycleDialog: false,
      closeCycleDialogTitle: '',
      closeCycleDialogMessage: '',
      showCreateBillingCycleDialog: false,
      ids: [],
      getCyclesIds: [],
      showReverseCycleDialog: false,
      stepToReverse: 0,
      reverseMessage: '',
      formattedBillingDate: '',
      showReportsDialog: false,
      showGeneralReportsDialog: false,
      generalReports: [],
      showIndividualDialog: false,
      individualTask: '',
      individualCustkey: '',
      queries: [],
    }
  },
  computed: {
    
  },
  watch: {
    onlyOpen: function (value) {
      this.getBillingCycles(true, '', []);
    },
    billingGroup: function (value) {
      if (value == '')
        this.selectedBillingGroup = null;
      else {
        this.selectedBillingGroup = this.billingGroups.filter(a => a.id == value)[0];
        this.getReports();
        this.formattedBillingDate = moment(String(this.selectedBillingGroup.billingDate)).format('DD/MM/YYYY');
      }
    },
  },
  created() {
    this.connection = new HubConnectionBuilder().withUrl("/hub").build();
    this.thisPage = this;
    this.$material.locale.dateFormat = 'yyyy-MM-dd';

    this.getSettings();
    this.getBillingCycles(true, '', []);
    this.getGeneralReports();
    this.getQueries();
  },
  mounted() {
    this.connection.start();

    this.connection.on('NewBillingCycles', payload => {
      this.getBillingCycles(false, 'New', payload);
    });

    this.connection.on('UpdatedBillingCycles', payload => {
      this.getBillingCycles(false, 'Updated', payload);
    });
  },
  beforeDestroy() {
    this.connection.stop();
  },
  methods: {
    getSettings() {
      axios.post('/Billing/GetSettings')
        .then(response => {
          if (response.status == 200) {
            this.userBillingGroups = response.data.billingGroups;
            this.globalPayByDate = response.data.globalPayByDate;
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    getBillingCycles(onLoad, action, ids) {
      this.getCyclesIds = [];

      if (!onLoad) {
        if (ids.length > 0) {
          var cnt = 0;

          for (var i = 0; i < ids.length; i++) {
            cnt = this.userBillingGroups.filter(a => a.id == ids[i].billingGroupId).length;
            if (cnt != 0)
              this.getCyclesIds.push(ids[i].billingCycleId);
          }
        }

        if (this.getCyclesIds.length == 0)
          return;
      }

      var parameters = {
        OnlyOpen: this.onlyOpen,
        BillingCycleIds: this.getCyclesIds,
      };

      axios.post('/Billing/GetBillingCycles', parameters)
        .then(response => {
          if (response.status == 200) {
            console.log(response.data);

            var res = [];

            for (var i = 0; i < response.data.length; i++) {
              res.push({
                id: 'bg:' + response.data[i].billingGroupId + '_cid:' + response.data[i].billingCycleId,
                label: response.data[i].name,
                billingGroupId: response.data[i].billingGroupId,
                billingCycleId: response.data[i].billingCycleId,
                isOpen: response.data[i].isOpen,
                sdClose: response.data[i].sdClose,
                sdStart: response.data[i].sdStart,
                step1: response.data[i].step1,
                step2: response.data[i].step2,
                step3: response.data[i].step3,
                step4: response.data[i].step4,
                step5: response.data[i].step5,
                step6: response.data[i].step6,
                taskError: response.data[i].taskError,
                taskStatus: response.data[i].taskStatus,
                canReverse: response.data[i].canReverse,
                billingDate: response.data[i].billingDate,
              });
            }

            if (action == 'New') {
              for (var i = 0; i < res.length; i++) {
                this.billingGroups.push(res[i]);
                this.billingGroups = this.billingGroups.sort((a, b) => (a.billingGroupId - b.billingGroupId || b.billingDate.localeCompare(a.billingDate)));
              }
            }
            else if (action == 'Updated') {
              if (response.data.length == 0) {
                this.getBillingCycles(true, '', []);
              }

              for (var i = 0; i < res.length; i++) {
                var idx = this.billingGroups.indexOf(this.billingGroups.filter(a => a.id == res[i].id)[0]);
                this.billingGroups.splice(idx, 1, res[i]);

                this.billingGroups = this.billingGroups.sort((a, b) => (a.billingGroupId - b.billingGroupId || b.billingDate.localeCompare(a.billingDate)));
              }
            }
            else {
              res = res.sort((a, b) => (a.billingGroupId - b.billingGroupId || b.billingDate.localeCompare(a.billingDate)));
              this.billingGroups = res;
              this.selectedBillingGroup = null;
            }

            if (this.billingGroups.filter(a => a.id == this.billingGroup).length == 0) {
              this.selectedBillingGroup = null;
              this.billingGroup = '';
            } else {
              this.selectedBillingGroup = this.billingGroups.filter(a => a.id == this.billingGroup)[0];
            }
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    closeBillingCycle() {
      axios.post('/Billing/CloseBillingCycle?BillingGroupId=' + this.selectedBillingGroup.billingGroupId)
        .then(response => {
          if (response.status == 200) {
            
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    createBillingCycleComplete() {
      this.showCreateBillingCycleDialog = false;
    },
    cancelOpenNewCycle() {
      this.showCreateBillingCycleDialog = false;
    },
    getReports() {
      axios.get('/Billing/GetReports')
        .then(response => {
          if (response.status == 200) {
            this.reports = response.data;
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    showReverseConfirmation() {
      if (this.selectedBillingGroup == null)
        return;

      this.stepToReverse = 0;

      if (this.selectedBillingGroup.step6 == 1 || (this.selectedBillingGroup.step6 == 2 && this.selectedBillingGroup.taskStatus == 4))
        this.stepToReverse = 6;
      else if (this.selectedBillingGroup.step4 == 1 || (this.selectedBillingGroup.step4 == 2 && this.selectedBillingGroup.taskStatus == 4))
        this.stepToReverse = 4;
      else if (this.selectedBillingGroup.step3 == 1 || (this.selectedBillingGroup.step3 == 2 && this.selectedBillingGroup.taskStatus == 4))
        this.stepToReverse = 3;
      else if (this.selectedBillingGroup.step1 == 1 || (this.selectedBillingGroup.step1 == 2 && this.selectedBillingGroup.taskStatus == 4))
        this.stepToReverse = 1;

      this.reverseMessage = this.$t('billing.areYouSureYouWantToReverseStep') + ' ' + this.stepToReverse + ' ?';
      this.showReverseCycleDialog = true;
    },
    runBillingStepReverse() {
      var parameters = {
        BillingGroupId: this.selectedBillingGroup.billingGroupId,
        Step: this.stepToReverse,
      };

      axios.post('/Billing/RunBillingStepReverse', parameters)
        .then(response => {
          if (response.status == 200) {

          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    printReport(reportId) {
      var parameters = {
        BillingCycleId: this.selectedBillingGroup.billingCycleId,
        ReportId: reportId
      };

      
      axios.post('/Billing/CreateReport', parameters)
        .then(response => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    getGeneralReports() {
      axios.get('/Billing/GetGeneralReports')
        .then(response => {
          if (response.status == 200) {
            this.generalReports = response.data;
          }
        })
        .catch(err => {
          err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$alertMsg(err.data.data.text)
        })
    },
    printGeneralReport(reportId) {
      
      axios.post('/Billing/CreateGeneralReport?reportId=' + reportId)
        .then(response => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    individualDialog(task) {
      this.individualTask = task;
      this.showIndividualDialog = true;
    },
    cancelIndividual() {
      this.individualCustkey = '';
      this.showIndividualDialog = false;
    },
    confirmIndividualTask() {
      if (this.individualCustkey == '')
        return;

      var parameters = {
        custkey: this.individualCustkey
      };

      this.$store.state.notifier.asyncBlock(
        axios.post(this.individualTask == 'bill' ? '/Billing/RunIndividualBilling' : '/Billing/RunReverseIndividualBilling', parameters),
        response => {
          if (response.status == 200) {
            this.individualCustkey = '';
            this.showIndividualDialog = false;
            this.$alertMsg(this.individualTask == 'bill' ? this.$t('billing.billCompletedSuccessfully') : this.$t('billing.reverseCompletedSuccessfully'), 2);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    getQueries() {
      if (this.offlineModeState)
        return;

      axios.get('/CustomQuery/GetQueries?locationId=11')
        .then(response => {
          if (response.status == 200) {
            if (response.data == null)
              this.queries = [];
            else
              this.queries = response.data;
          }
        })
        .catch(err => {
          err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$alertMsg(err.data.data.text)
        })
    },
  },
}
